import { Typography } from '@sede-enterprise/shell-ds-react-framework';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { SPACING_2, SPACING_4, SPACING_5 } from 'constants/theme-constants';
import { motion } from 'framer-motion';
import styled from 'styled-components';

export const CompanyListScrollContainer = styled.div`
  height: 400px;
  @media screen and (max-width: ${cxTheme.breakpoints.tablet}px) {
    height: calc(100vh - 200px);
  }
  overflow-y: auto;
  scroll-behavior: smooth;
  margin: ${cxTheme.spacing[SPACING_5]} 0 ${cxTheme.spacing[SPACING_4]};

  ${({ theme }) => `
  &::-webkit-scrollbar {
    background-color: ${theme.background.section};
    width: ${cxTheme.spacing[SPACING_2]};
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${theme.background.mask};
    border-radius: ${cxTheme.borderRadius.secondaryRadius};

    &:hover {
      background-color: ${theme.additional.mask.strong};
    }
  }`}
`;

export const CompanyListWrapper = styled(motion.ul)`
  ${({ theme }) => `
    box-sizing: border-box;
    display: flex;

    flex-direction: column;
    align-items: center;
  `}
`;

export const CompanyListItemWrapper = styled(motion.li)`
  ${({ theme }) => `
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    min-height: ${cxTheme.spacing[9]};
    width: 100%;
    background-color: inherit;
    padding: 0 25px 0 ${cxTheme.spacing[SPACING_4]};
    outline: none;
    color: ${theme.onSurface.surface.default.border.strong};

    &:hover:not([aria-disabled="true"]) {
      cursor: pointer;
    }

    &[aria-disabled="true"]:focus {
      box-shadow: inset 0 0 0 2px ${theme.additional.focus.subtle};
    }

    &:focus-visible {
      box-shadow: inset 0 0 0 2px ${theme.additional.focus.subtle};
    }

    &[aria-disabled="true"] {
      background-color: ${theme.background.section} !important;
      &:hover {
        cursor: default;
      }
    }
  `}
`;

export const CompanyListLabel = styled.h4`
  ${({ theme }) => `
    ${Typography.paragraph.medium.normal};
  `}
`;

export const CompanyListSubLabel = styled.h5`
  ${({ theme }) => `
    ${Typography.label.small.normal};
    color: ${theme.onSurface.surface.default.text.subtle};
    margin: 0;
  `}
`;

export const CompanyListLabelWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
  `}
`;

export const CompanyNotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CompanyLoaderWrapper = styled.div`
  ${({ theme }) => `
      font-size: 4em;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding-top: ${cxTheme.spacing[8]};
      justify-content: start;
  `}
`;

export const CompanyNotFoundIcon = styled.div`
  font-size: 28px;
  margin-bottom: ${({ theme }) => {
    return `${cxTheme.spacing[SPACING_4]}`;
  }};

  .shell-icon {
    width: 100%;
    height: 100%;
    fill: ${({ theme }) => `${theme.accent.primary.strong}`};
`;
